import React from 'react';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { withValue, hook } from '@g4/automation-hooks';
import { TrackClick } from '@g4/trackster';

import { conditionallyRequired } from '../../../../../utils/propTypesUtils';
import { Box, Popover, Media } from '../../../../Boneyard';
import { getPrice } from '@g4/next-furniture/Price/Price';
import InfoIcon from '../../../../InfoIcon';

const propTypes = {
  name: PropTypes.string.isRequired,
  amount: PropTypes.number,
  currencySymbol: PropTypes.string,
  popoverContent: PropTypes.node,
  destination: conditionallyRequired(
    PropTypes.string,
    props => props.popoverContent
  ),
  amountStyles: PropTypes.object,
  theme: PropTypes.object,
  automationHook: PropTypes.string.isRequired,
  hidePrice: PropTypes.bool,
  isPromoApplied: PropTypes.bool,
  promoAppliedLabel: PropTypes.string,
};

/* TODO
  - testing
  - PriceBreakdownList use case?
  - send components to name and amount as primary option
*/
const PriceBreakdownItem = ({
  theme,
  name,
  amount,
  destination,
  currencySymbol = '$',
  popoverContent,
  automationHook,
  amountStyles = {},
  hidePrice,
  isPromoApplied,
  promoAppliedLabel,
}) => {
  const { price } = getPrice(amount, currencySymbol);

  return (
    <Media>
      {mq => (
        <Box w="100%" d="flex" justifyContent="space-between">
          <Box d="flex">
            <span {...hook(automationHook)}>{name}</span>
            {popoverContent && (
              <Box ml={1}>
                <Popover
                  backgroundColor={
                    theme.colors.cart.priceBreakdown.infoPopover.background
                  }
                  content={<Box p={3}>{popoverContent}</Box>}
                  showClose={false}
                  maxWidth={mq.lte('xs') ? 'calc(100% - 60px)' : '400px'}
                  label={`${name} popover`}
                  horizontalOffset={mq.lte('sm') ? 2 : 0}
                  triggerWrapper={children => (
                    <TrackClick
                      category="site_click_tracking"
                      action="Trip Summary"
                      label={`Round Trip Discount | ${price} | ${destination}`}
                    >
                      {children}
                    </TrackClick>
                  )}
                  automationHook={withValue(automationHook, 'popover')}
                >
                  <InfoIcon />
                </Popover>
              </Box>
            )}
          </Box>
          <Box pl={2}>
            <span
              style={{
                fontSize: mq.lte('sm') ? 16 : 18,
                ...amountStyles,
              }}
              {...hook(automationHook, 'value')}
            >
              {isPromoApplied ? promoAppliedLabel : (hidePrice ? '$ --.--' : price)}
            </span>
          </Box>
        </Box>
      )}
    </Media>
  );
};

PriceBreakdownItem.propTypes = propTypes;

export default withTheme(PriceBreakdownItem);
